import { REACT_APP_EMAIL_BASE_URL } from "../utils/urls";

const postDataMail = async (data: any, uri: any) => {
  const response = await fetch(`${REACT_APP_EMAIL_BASE_URL}/${uri}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return await response.json();
};

export default postDataMail;
